import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Row, Column } from 'react-foundation';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Button';
import { Error } from '../../components/Error';
import { Icon } from '../../components/Icon';
import { selectErrors } from '../../modules/global/selectors';
import * as simActions from '../../modules/sims/actions';
import { makeSelectFetching, makeSelectSims, makeSelectCurrentSimData, makeSelectNonActivatedSims } from '../../modules/sims/selectors';
import { selectCustomerData } from '../../modules/customer/selectors';
import SimList from './SimList';
import { FilterInput } from './FilterInput';
import { getAccountId, getUIString, someEndpointCallFailed } from '../../utils/helpers';
import NonActivatedSimsFeatures from './NonActivatedSimsFeatures';
import { formatMsisdn } from '../../utils/helpers';

const Container = styled.div`
	margin: auto;
	width: 85%;
`;

const Centralize = styled.div`
	text-align: center;
	h3 {
		font-size: 65px;
		margin: 0;
	}
`;

const SimAmountStatus = styled.div`
	text-align: center;
	h4 {
		margin-bottom: 0em;
	}

	.mnp-notice {
		padding-bottom: 2.5rem;
	}
	margin-bottom: 2.5em;
	margin-top: 4em;
`;

const CenterButton = styled.div`
	text-align: center;
`;

const Search = styled.div`
	margin: auto;
	width: 84%;
	max-width: 390px;
	margin-bottom: 2rem;
`;

const Title = styled.div`
	margin-top: 2rem;
`;

const ReloadPageNotice = styled.div`
	text-align: center;
	margin: auto;
	span {
		display: block;
		margin-bottom: 1em;
		font-size: 1.4rem;
	}
`;

export class SimsPage extends React.PureComponent {
	// eslint-disable-line react/prefer-stateless-function
	constructor(props) {
		super(props);
		this.state = {
			filter: '', // TODO is this needed?
			filterTerm: '',
			selectedSort: '',
			columns: {
				voice: true,
				data: true,
				sms: true
			},
			showAll: false
		};
	}

	componentDidMount() {
		const { fetchSims, fetchNonActivatedSims, accountType } = this.props;
		fetchSims(getAccountId());
		if (accountType === 'consumer') {
			fetchNonActivatedSims(getAccountId());
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.props.currentSim !== nextProps.currentSim) {
			if (nextProps.currentSim !== null) {
				this.props.clearCurrentSim();
			}
		}
	}

	handleSelectChange = (e) => {
		this.setState({
			selectedSort: e.target.value
		});
	};

	handleFilterChange = (value) => {
		this.setState({
			filterTerm: value
		});
	};

	matchesFilter = (item) => {
		return item !== undefined && item.toLowerCase().includes(this.state.filterTerm.toLowerCase());
	};

	isFilterDefined = () => {
		return this.state.filterTerm !== '';
	};

	filterList(sims) {
		const tags = [];
		if (this.isFilterDefined() && sims !== null) {
			const simobj = JSON.parse(JSON.stringify(sims));
			Object.keys(simobj).forEach((key) => {
				const simName = simobj[key].name;
				const zeroFormatSimMsisdn = formatMsisdn(simobj[key].msisdn);
				if (this.matchesFilter(simName) || this.matchesFilter(zeroFormatSimMsisdn) || this.matchesFilter(zeroFormatSimMsisdn.replaceAll(' ', ''))) {
					tags.push(simobj[key]);
				}
			});
			return tags;
		}
		return sims;
	}

	reload = () => {
		window.location.reload();
	};

	render() {
		const { sims, fetching, accountType, nonActivatedSims, errors, billingPeriods, activeBillingPeriod, allUsagesData, fetchingUsage, offeringType } = this.props;
		const canShowActiveSims = sims !== null && !someEndpointCallFailed(errors, ['status=active']);
		const shouldShowErrorMessage = !canShowActiveSims && (!nonActivatedSims || nonActivatedSims.length === 0) && (!fetching || someEndpointCallFailed(errors, ['status=active']));

		return (
			<article>
				<Helmet title={getUIString(accountType, 'SimsPage.header')} meta={[{ name: 'description', content: 'Simmit' }]} />
				<Container>
					<div>
						<Centralize>
							<Title>
								<Icon name="medium--sims" />
								<h3>{getUIString(accountType, 'SimsPage.header')}</h3>
							</Title>
						</Centralize>
						<NonActivatedSimsFeatures nonActivatedSims={nonActivatedSims} offeringType={offeringType} />
						{canShowActiveSims && (
							<div>
								{accountType === 'business' && (
									<CenterButton>
										<Link to="/account/activateSubscription">
											<Button className="wide outlined">Lisää uusi liittymä...</Button>
										</Link>
									</CenterButton>
								)}
								<SimAmountStatus>
									{sims.length === 0 && <h4>Yhtään liittymää ei ole käytössä. Yhyy!</h4>}
									{sims.length > 0 && (
										<h4>{`${sims.length} ${sims.length === 1 ? getUIString(accountType, 'SimsPage.singleSim') : getUIString(accountType, 'SimsPage.severalSims')} käytössä. Jihuu!`}</h4>
									)}
									<span className={'mnp-notice'}>(Liittymät joiden numeronsiirto on kesken, eivät näy tässä)</span>
								</SimAmountStatus>
								{accountType === 'business' && (
									<Row>
										<Column className="large-6 columns ">
											<Search>
												<FilterInput onChange={this.handleFilterChange} />
											</Search>
										</Column>
										<Column className="large-5 columns ">
											<select defaultValue={''} onChange={this.handleSelectChange}>
												<option value="" disabled>
													Järjestä kulutuksen mukaan
												</option>
												<option value="data">Data</option>
												<option value="voice">Puhe</option>
												<option value="message">Viestit</option>
											</select>
										</Column>
									</Row>
								)}
								<SimList
									sims={this.filterList(sims)}
									selectedSort={this.state.selectedSort}
									billingPeriods={billingPeriods}
									accountType={accountType}
									activeBillingPeriod={activeBillingPeriod}
									allUsagesData={allUsagesData}
									fetchingUsage={fetchingUsage}
									offeringType={offeringType}
								/>
								{accountType === 'business' && !fetching && sims.length < 1 && (
									<CenterButton>
										<p>Yritykselläsi ei ole yhtään liittymää käytössä. Ota liittymä käyttöön alla olevasta painikkeesta</p>
										<Link to="/account/activateSubscription">
											<Button className="wide outlined">Lisää uusi liittymä...</Button>
										</Link>
									</CenterButton>
								)}
								{!fetching && (
									<ReloadPageNotice>
										<span>Otitko juuri liittymän käyttöön? Odota vielä hetki ja päivitä sitten sivu</span>
										<Button onClick={this.reload}>Päivitä sivu</Button>
									</ReloadPageNotice>
								)}
							</div>
						)}
					</div>
					{shouldShowErrorMessage && <Error message={'Jotain meni vikaan. Yritä myöhemmin uudestaan tai ota yhteyttä asiakaspalveluumme'} />}
				</Container>
			</article>
		);
	}
}

SimsPage.propTypes = {
	fetchSims: PropTypes.func,
	sims: PropTypes.array,
	fetching: PropTypes.bool,
	currentSim: PropTypes.object,
	clearCurrentSim: PropTypes.func,
	accountType: PropTypes.string,
	nonActivatedSims: PropTypes.array,
	fetchNonActivatedSims: PropTypes.func,
	consumer3PackagePrices: PropTypes.object,
	submitNumsi: PropTypes.func,
	errors: PropTypes.array,
	offeringType: PropTypes.string
};

const mapStateToProps = createStructuredSelector({
	customer: selectCustomerData,
	errors: selectErrors,
	fetching: makeSelectFetching(),
	sims: makeSelectSims(),
	currentSim: makeSelectCurrentSimData(),
	nonActivatedSims: makeSelectNonActivatedSims()
});

const mapDispatchToProps = {
	...simActions
};

export default connect(mapStateToProps, mapDispatchToProps)(SimsPage);
